import axios from "axios";
import baseAPIVMS from "./baseApiVms";

const accessurl = sessionStorage.getItem("role");

let userAccessUrl;
if (accessurl == 2 || accessurl == 7) {
    userAccessUrl = "/v2/clearing/admin/abx";
} else if (accessurl == 5) {
    userAccessUrl = "/v2/clearing/operator";
}
const getDepositApi = (serialNumber, limit, offset, owner, startDate, endDate, status, type) => {
    return axios.get(userAccessUrl + "/get/list/deposit", {
        params: {
            serial_number: serialNumber,
            type: type,
            limit: limit,
            offset: offset,
            owner: owner,
            startDate: startDate,
            endDate: endDate,
            status: status,
        },
    });
};

const getMetalApi = (activity, owner, startDate, endDate, serial_number, hallmark, status, dateType, limit, offset, contract_id, type) => {
    return axios.get(userAccessUrl + "/get/list/bullion", {
        params: {
            activity: activity,
            owner: owner,
            startDate: startDate,
            endDate: endDate,
            serial_number: serial_number,
            hallmark: hallmark,
            status: status,
            date_type: dateType,
            limit: limit,
            offset: offset,
            contract_id: contract_id,
            type: type,
        },
    });
};

const getDetailDepositApi = (id) => {
    return axios.get(userAccessUrl + "/get/detail/deposit/" + id);
};
const getDetailMetalApi = (id) => {
    return axios.get(userAccessUrl + "/get/detail/deposit/bullion/" + id);
};

const getClientApi = (type) => {
    return axios.get(userAccessUrl + "/get/list_depositor", {
        params: {
            type: type,
        },
    });
};

const getWithdrawApi = (offset, perPage, type, owner, startDate, endDate, status, serialNumber,denom, pieces) => {
    return axios.get(userAccessUrl + "/get/list/withdrawal", {
        params: {
            owner: owner,
            serial_number: serialNumber,
            startDate: startDate,
            endDate: endDate,
            status: status,
            limit: perPage,
            offset: offset,
            type: type,
            denom: denom,
            pieces: pieces
        },
    });
};

const getWithdrawOffExcApi = (client, startDate, endDate, status, limit, offset, denom, pieces, currentPage, perPage) => {
    return baseAPIVMS.get( "/vaulting/offexchange/withdrawal", {
        params: {
            currentPage: currentPage,
            perPage: perPage,
            search: client, 
            startDate: startDate, 
            endDate: endDate, 
            status: status, 
            limit: limit, 
            offset: offset, 
            denom: denom, 
            pieces: pieces
        },
    });
};

const getContractApi = () => {
    return axios.get("/v2/attributes/contract");
};

const getRealisationApi = (id, seri, startDate, endDate, limit, offset) => {
    return axios.get("/v2/clearing/admin/abx/get/detail_realisasi/" + id + "/" + seri, {
        params: {
            startDate: startDate,
            endDate: endDate,
            limit: limit,
            offset: offset,
        },
    });
};
const getHistoryRealitationApi = (realisation_id, limit, offset) => {
    return axios.get("/v2/clearing/admin/abx/history_realisasi/" + realisation_id, {
        params: {
            limit: limit,
            offset: offset,
        },
    });
};
const getHistoryDetailRealitationApi = (history_id, limit, offset) => {
    return axios.get("/v2/clearing/admin/abx/detail_history/" + history_id, {
        params: {
            limit: limit,
            offset: offset,
        },
    });
};

export {
    getDepositApi,
    getMetalApi,
    getClientApi,
    getDetailDepositApi,
    getDetailMetalApi,
    getWithdrawApi,
    getWithdrawOffExcApi,
    getContractApi,
    getRealisationApi,
    getHistoryRealitationApi,
    getHistoryDetailRealitationApi,
};
